module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av517-41cc47316148863c43194ae47377d09f.jpg";